import services from './_services'

export default {
  getTags () {
    return services.get(process.env.ROOT_API + '/tag/')
  },
  addTag (tagName) {
    return services.post(process.env.ROOT_API + '/tag/', {name: tagName})
  },
  addTagToOrganization (organizationID, tagID) {
    return services.post(process.env.ROOT_API + '/organizations/' + organizationID + '/tag/' + tagID, {})
  },
  removeTagFromOrganization (organizationID, tagID) {
    return services.deleteCall(process.env.ROOT_API + '/organizations/' + organizationID + '/tag/' + tagID, {})
  }
}



// WEBPACK FOOTER //
// ./src/api/tags.js